import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TipoAnexoRenovacaoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // Listar todos os tipos de anexo de renovação
  list(params?: any): Observable<any[]> {
    const httpParams = params ? new HttpParams({ fromObject: params }) : this.params;
    return this.apiService
      .get<{ data: any[] }>(`${this.path}/getAllTipoAnexoRenovacao`, httpParams)
      .pipe(map(response => response.data));
  }

  // Buscar tipo de anexo de renovação por ID
  public show(id: number | string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getTipoAnexoRenovacaoById/${id}`)
      .pipe(map(response => response.object));
  }

  // Criar novo tipo de anexo de renovação
  public store(payload: any | FormGroup): Observable<any> {
    const dto = payload instanceof FormGroup ? payload.value : payload;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddTipoAnexoRenovacao`, dto)
      .pipe(map(response => response.object));
  }

  // Atualizar tipo de anexo de renovação existente
  public update(payload: any | FormGroup): Observable<any> {
    const dto = payload instanceof FormGroup ? payload.value : payload;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateTipoAnexoRenovacao`, dto)
      .pipe(map(response => response.object));
  }

  // Eliminar tipo de anexo de renovação por ID
  delete(id: number | string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoAnexoRenovacaoById/${id}`);
  }
}